import { IBusiness, ICategory, IComment, INeighBourhood, IReservation, IService } from "../state/api/types";

// export const businesses: IBusiness[] = [
//     {
//         "id": "1", "name": "Bird Island :a unique private Island in Belize.", "lat": -34.90492763039531, "lng": -56.20576407500152, "img": "https://picsum.photos/200", "rating": "4.5",
//         "openHours": [
//             { "day": "Monday", "open": "9:00", "close": "18:00" },
//             { "day": "Tuesday", "open": "9:00", "close": "18:00" },
//             { "day": "Wednesday", "open": "9:00", "close": "18:00" },
//             { "day": "Thursday", "open": "9:00", "close": "18:00" },
//             { "day": "Friday", "open": "9:00", "close": "18:00" },
//             { "day": "Saturday", "open": "9:00", "close": "18:00" },
//             { "day": "Sunday", "open": "9:00", "close": "18:00" },
//         ],
//         "services": [
//             {
//                 "id": 1,
//                 "name": "Hair Salon",
//                 "description": "Corte de pelo para dama",
//                 "price": 25,
//                 "duration": "15 minutes",
//                 "category": "hairSalon",
//                 "isFavorite": false,
//                 "isBookmarked": false,
//                 "isSelected": true,
//             },
//             {
//                 "id": 2,
//                 "name": "Beard Trim",
//                 "description": "Corte de pelo para dama",
//                 "price": 40,
//                 "duration": "30 minutes",
//                 "category": "beard",
//                 "isFavorite": false,
//                 "isBookmarked": false,
//                 "isSelected": true,
//             },
//             {
//                 "id": 3,
//                 "name": "Nails",
//                 "description": "Corte de pelo para dama",
//                 "price": 10,
//                 "duration": "1 hour",
//                 "category": "nails",
//                 "isFavorite": false,
//                 "isBookmarked": false,
//                 "isSelected": false,
//             },
//         ]
//     },
//     {
//         id: "2", name: "Lobelia Sagasta", lat: -34.90384019989968, lng: -56.204138387100095, img: "https://picsum.photos/200", rating: "3.5", services: [
//             {
//                 id: 1,
//                 name: "Hair Salon",
//                 description: "Corte de pelo para dama",
//                 price: 25,
//                 duration: "15 minutes",
//                 category: "hairSalon",
//                 isFavorite: false,
//                 isBookmarked: false,
//                 isSelected: true,
//             },
//             {
//                 id: 2,
//                 name: "Beard Trim",
//                 description: "Corte de pelo para dama",
//                 price: 40,
//                 duration: "30 minutes",
//                 category: "beard",
//                 isFavorite: false,
//                 isBookmarked: false,
//                 isSelected: true,
//             }
//         ]
//     },
//     {
//         id: "3", name: "Subway", lat: -34.905730953456974, lng: -56.19820593065046, img: "https://picsum.photos/200", rating: "4.5", services: [
//             {
//                 id: 3,
//                 name: "Nails",
//                 description: "Corte de pelo para dama",
//                 price: 10,
//                 duration: "1 hour",
//                 category: "nails",
//                 isFavorite: false,
//                 isBookmarked: false,
//                 isSelected: false,
//             },
//             {
//                 id: 4,
//                 name: "Massage",
//                 description: "Corte de pelo para dama",
//                 price: 15,
//                 duration: "45 minutes",
//                 category: "massage",
//                 isFavorite: false,
//                 isBookmarked: false,
//                 isSelected: false,
//             },
//         ]
//     },
//     {
//         id: "4", name: "Papa Johns", lat: -34.907344976902394, lng: -56.206162732530345, img: "https://picsum.photos/200", rating: "5.0", services: [
//             {
//                 id: 5,
//                 name: "Hair Salon",
//                 description: "Corte de pelo para dama",
//                 price: 25,
//                 duration: "15 minutes",
//                 category: "hairSalon",
//                 isFavorite: false,
//                 isBookmarked: false,
//                 isSelected: true,
//             },
//             {
//                 id: 6,
//                 name: "Beard Trim",
//                 description: "Corte de pelo para dama",
//                 price: 40,
//                 duration: "30 minutes",
//                 category: "beard",
//                 isFavorite: false,
//                 isBookmarked: false,
//                 isSelected: true,
//             },
//         ]
//     },
//     {
//         id: "5", name: "MacDonalds", lat: -34.90887577544645, lng: -56.2103219292277, img: "https://picsum.photos/200", rating: "4.2", services: [
//             {
//                 id: 7,
//                 name: "Nails",
//                 description: "Corte de pelo para dama",
//                 price: 10,
//                 duration: "1 hour",
//                 category: "nails",
//                 isFavorite: false,
//                 isBookmarked: false,
//                 isSelected: false,
//             },
//             {
//                 id: 8,
//                 name: "Massage",
//                 description: "Corte de pelo para dama",
//                 price: 15,
//                 duration: "45 minutes",
//                 category: "massage",
//                 isFavorite: false,
//                 isBookmarked: false,
//                 isSelected: false,
//             },
//         ]
//     },
//     // { id: "6", name: "Wendys", lat: -34.90457806014349, lng: -56.20582534163791, img: "https://picsum.photos/200", rating: "3.8" },
//     // { id: "7", name: "Pizza Hut", lat: -34.90359665216177, lng: -56.2074466499283, img: "https://picsum.photos/200", rating: "2.3" },
//     // { id: "8", name: "Taco Bell", lat: -34.90642268167554, lng: -56.20166418729791, img: "https://picsum.photos/200", rating: "2.4" },
// ];

// export const reservations: IReservation[] = [
//     {
//         id: "1",
//         businessId: "1",
//         dateCreated: 1655042141,
//         date: 1655042141,
//         userId: "1",
//         review: "",
//         businessUserId: "",
//         status: "pending",
//         idBillingInfo: "",
//         services: ["1", "2"]
//     },
//     {
//         id: "1",
//         businessId: "1",
//         dateCreated: 1655042141,
//         date: 1655042141,
//         userId: "1",
//         review: "",
//         businessUserId: "",
//         status: "pending",
//         idBillingInfo: "",
//         services: ["1", "2"]
//     },
// ];

// export const services: IService[] = [
//     {
//         id: 1,
//         name: "Hair Salon",
//         description: "Corte de pelo para dama",
//         price: 25,
//         duration: "15 minutes",
//         category: "hairSalon",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: true,
//     },
//     {
//         id: 2,
//         name: "Beard Trim",
//         description: "Corte de pelo para dama",
//         price: 40,
//         duration: "30 minutes",
//         category: "beard",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: true,
//     },
//     {
//         id: 3,
//         name: "Nails",
//         description: "Corte de pelo para dama",
//         price: 10,
//         duration: "1 hour",
//         category: "nails",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: false,
//     },
//     {
//         id: 4,
//         name: "Massage",
//         description: "Corte de pelo para dama",
//         price: 15,
//         duration: "45 minutes",
//         category: "massage",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: false,
//     },
//     {
//         id: 5,
//         name: "Hair Salon",
//         description: "Corte de pelo para dama",
//         price: 25,
//         duration: "15 minutes",
//         category: "hairSalon",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: true,
//     },
//     {
//         id: 6,
//         name: "Beard Trim",
//         description: "Corte de pelo para dama",
//         price: 40,
//         duration: "30 minutes",
//         category: "beard",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: true,
//     },
//     {
//         id: 7,
//         name: "Nails",
//         description: "Corte de pelo para dama",
//         price: 10,
//         duration: "1 hour",
//         category: "nails",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: false,
//     },
//     {
//         id: 8,
//         name: "Massage",
//         description: "Corte de pelo para dama",
//         price: 15,
//         duration: "45 minutes",
//         category: "massage",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: false,
//     },
//     {
//         id: 9,
//         name: "Beard Trim",
//         description: "Corte de pelo para dama",
//         price: 40,
//         duration: "30 minutes",
//         category: "beard",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: true,
//     },
//     {
//         id: 10,
//         name: "Nails",
//         description: "Corte de pelo para dama",
//         price: 10,
//         duration: "1 hour",
//         category: "nails",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: false,
//     },
//     {
//         id: 11,
//         name: "Massage",
//         description: "Corte de pelo para dama",
//         price: 15,
//         duration: "45 minutes",
//         category: "massage",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: false,
//     },
//     {
//         id: 12,
//         name: "Beard Trim",
//         description: "Corte de pelo para dama",
//         price: 40,
//         duration: "30 minutes",
//         category: "beard",
//         isFavorite: false,
//         isBookmarked: false,
//         isSelected: true,
//     },
// ];

// export const comments: IComment[] = [
//     {
//         id: '1',
//         name: "John Doe",
//         content: "Excelente servicio, personas muy amables. Recomiendo.",
//         rating: 4.5,
//         date: "September 2021",
//     },
//     {
//         id: '2',
//         name: "Pepe Lopez",
//         content: "Excelente servicio, personas muy amables.",
//         rating: 3.2,
//         date: "July 2018",
//     },
// ];

export const categories: ICategory[] = [
    { id: '1', name: 'Cuidado de piel' },
    { id: '2', name: 'Peluquería' },
    { id: '3', name: 'Dental' },
    { id: '4', name: 'Piercing' },
    { id: '5', name: 'Servicios profesionales' },
    { id: '6', name: 'Animales' },
    { id: '7', name: 'Bienestar y spa' },
    { id: '8', name: 'Health & Fitness' },
    { id: '9', name: 'Maquillaje' },
    { id: '10', name: 'Masajes' },
    { id: '11', name: 'Uñas' },
    { id: '12', name: 'Cuidado de animales' },
    { id: '13', name: 'Estética' },
    { id: '14', name: 'Cejas y Pestañas' },
    { id: '15', name: 'Tatuajes' },
    { id: '16', name: 'Otro' },
]

export const neighbourhoods: INeighBourhood[] = [
    { id: "1", name: "Pocitos" },
    { id: "2", name: "Parque Batlle" },
    { id: "3", name: "Aguada" },
    { id: "4", name: "Cordón" },
    { id: "5", name: "Blanqueada" },
    { id: "6", name: "Buceo" },
]